// src/client/renderer/vfx/items/audio-cues.ts
//
// Plan 17, Task 1.1 — Audio cue table for item VFX.
// Data-only literal: one cue per item, fired on cast-phase resolver hit.

import type { AudioCueId } from '../types';
import type { ItemId } from './item-vfx-types';

export const ITEM_VFX_AUDIO_CUES: Readonly<Record<ItemId, AudioCueId>> = {
  thunder_fist: 'sfx.item_thunder_fist',
  frost_blaster: 'sfx.item_frost_blaster',
  meteor_strike: 'sfx.item_meteor_strike',
  orbital_cannon: 'sfx.item_orbital_cannon',
  toxic_cloud: 'sfx.item_toxic_cloud',
  gravity_well: 'sfx.item_gravity_well',
  lightning_dash: 'sfx.item_lightning_dash',
  phoenix_potion: 'sfx.item_phoenix_potion',
  stone_skin: 'sfx.item_stone_skin',
  dimension_rift: 'sfx.item_dimension_rift',
  mystery_box: 'sfx.item_mystery_box',
  shadow_stalker: 'sfx.item_shadow_stalker',
  cursed_relic: 'sfx.item_cursed_relic',
  soul_duel: 'sfx.item_soul_duel',
};

export function audioCueForItem(itemId: ItemId): AudioCueId {
  return ITEM_VFX_AUDIO_CUES[itemId];
}
